import { Skeleton } from '@mui/material';
import { Helmet } from 'react-helmet';

const SkeletonPage = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>List Manager</title>
        <meta name="description" content="List Manager" />
      </Helmet>
      <Skeleton variant="rectangular" animation="pulse" height="100vh" width="100%" />
    </>
  );
};

export default SkeletonPage;
